import React from "react";
import Navbar from "@/components/Navbar";
import KineticHero from "@/components/KineticHero";
import GrandOpening from "@/components/GrandOpening";
import EditorialMarquee from "@/components/EditorialMarquee";
import Services from "@/components/Services";
import WhyChoose from "@/components/WhyChoose";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import Seo, { localBusinessSchema } from "@/components/Seo";
import { CONTACT } from "@/lib/content";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-[#0c0c0f] text-white">
      <Seo
        title="Premium PPF, Ceramic Coating & Auto Detailing in Edmonton"
        description="WTD Detailing & Tint — Edmonton's premium studio for Paint Protection Film, Ceramic Coating, Paint Correction, Interior Detailing, Spray-On Bed Liner, Headlight Restoration & Odor Removal. Experienced installers. Warranty coverage varies by product and service package."
        keywords="PPF Edmonton, Paint Protection Film Edmonton, Ceramic Coating Edmonton, Auto Detailing Edmonton, Paint Correction Edmonton, Headlight Restoration Edmonton, Bed Liner Edmonton"
        path="/"
        jsonLd={[localBusinessSchema({ contact: CONTACT })]}
      />
      <Navbar />
      <main>
        <KineticHero />
        <GrandOpening />
        <EditorialMarquee />
        <Services />
        <WhyChoose />
        <CTA />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
